import type { AssumableAdminRole } from 'src/auth/types';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

export function useAvailableAdminRoles() {
  const { data, error, isLoading, mutate } = useSWR<AssumableAdminRole[]>(
    endpoints.me.adminRoles,
    fetcher
  );

  return {
    adminRoles: data ?? [],
    adminRolesLoading: isLoading,
    adminRolesError: error,
    mutateAdminRoles: mutate,
  };
}
